export default __webpack_public_path__ + "static/media/aral-banner.94d4af56.jpg";